import { styled } from '@mui/material';
import { Box, Button, Form, Link, Stack, Text, TextInput, ThirdPartyButton } from 'shell/components';

const SignupPage = ({ device = 'desktop', loading, errors, form, handleChange, handleSignUp, signInWithGoogle }) => {
    return (
        <>
            <SignUpBox device={device}>
                <Stack alignItems={'center'} spacing={1} sx={{ marginBottom: 6 }}>
                    <Text component={'h1'} variant={'h6'} weight={'medium'}>
                        Create an Account
                    </Text>
                    <Text variant={'p1'} sx={{ textAlign: 'center' }}>
                        Sign up to access TimelyGrader’s advanced automated feedback and assessment system.
                    </Text>
                </Stack>
                <Form onSubmit={() => handleSignUp()}>
                    <InputStack>
                        <TextInput
                            error={Boolean(errors.email)}
                            helperText={errors.email}
                            label={'Email'}
                            value={form.email}
                            onChange={(e) => handleChange('email', e.target.value)}
                            placeholder={'Enter email'}
                            required
                        />
                    </InputStack>

                    <Stack sx={{ margin: (theme) => theme.spacing(6, 0, 3, 0) }}>
                        <Button loading={loading} type={'submit'}>
                            Sign Up
                        </Button>
                    </Stack>
                    <Stack alignItems={'center'}>
                        <SignUpText variant={'p3'}>
                            Already have an account? <Link to={'/'}>Login</Link>
                        </SignUpText>
                    </Stack>
                    <DividerStack alignItems={'center'} direction={'row'}>
                        <HalfDivider />
                        <Text sx={{ margin: '0 10px' }} color={'light'}>
                            OR
                        </Text>
                        <HalfDivider />
                    </DividerStack>
                    <Stack>
                        <ThirdPartyButton variant={'google'} onClick={signInWithGoogle}>
                            Continue with Google
                        </ThirdPartyButton>
                    </Stack>
                </Form>
            </SignUpBox>
            <Text color={'light'} variant={'p3'}>
                By signing up, you agree to TimelyGrader’s{' '}
                <Link
                    external
                    href={`https://docs.google.com/gview?url=${process.env.REACT_APP_TOS}&embedded=true`}
                    variant={'neutral'}
                >
                    Terms of Services
                </Link>{' '}
                and{' '}
                <Link
                    external
                    href={`https://docs.google.com/gview?url=${process.env.REACT_APP_PRIVACY_POLICY}&embedded=true`}
                    variant={'neutral'}
                >
                    {' '}
                    Privacy Policy.
                </Link>
            </Text>
        </>
    );
};

const SignUpBox = styled(Box)(({ theme, device }) => {
    return {
        marginTop: theme.spacing(12),
        padding: theme.spacing(7),
        height: 'fit-content',
        ...(device === 'mobile' && {
            position: 'relative',
            width: '100%',
            padding: 0,
        }),
        ...(device === 'tablet' && {
            width: 365,
            background: theme.palette.ensightful.shades[0],
            boxShadow: theme.palette.ensightful.shadows[1],
            borderRadius: '12px',
        }),
        ...(device === 'desktop' && {
            width: 450,
            background: theme.palette.ensightful.shades[0],
            boxShadow: theme.palette.ensightful.shadows[1],
            borderRadius: '12px',
        }),
    };
});

const InputStack = styled(Stack)(({ theme }) => {
    return {
        margin: theme.spacing(6, 0, 2, 0),
        gap: 6,
    };
});

const SignUpText = styled(Text)(({ theme }) => {
    return {
        color: theme.palette.ensightful.neutral[700],
    };
});

const DividerStack = styled(Stack)(({ theme }) => {
    return {
        margin: theme.spacing(6, 0),
    };
});

const HalfDivider = styled(Box)(({ theme }) => {
    return {
        flex: 1,
        height: '1px',
        backgroundColor: '#E0E0E0',
    };
});

export default SignupPage;
